export const SET_COMPOSE_CLICK = '[SET][COMPOSE_CLICK] messages';
export const SET_CASE_ID = '[SET][CASE_ID] from new dashboard';
export const SET_CASE_NUMBER = '[SET][CASE_NUMBER] from new dashboard';
export const SET_CASE_DETAIL = '[SET][CASE_DETAIL] from new dashboard';
export const RESET_CASE_ID = '[SET][RESET_CASE_ID] from new dashboard';
export const SET_SELECTED_TOGGLE_OPTION = '[SET][SELECTED_TOGGLE_OPTION] from new dashboard';
export const RESET_SELECTED_TOGGLE_OPTION = '[RESET][SELECTED_TOGGLE_OPTION] from new dashboard';
export const REFRESH_MESSAGE_COUNT = '[REFRESH][MESSAGE_COUNT] from new message';
